import React from "react";
import { Link } from "react-router-dom";

const AuthLayout = ({ children }) => {
  return (
    <div className="h-screen flex flex-col bg-white overflow-hidden">
      {/* Header */}
      <header className="shrink-0 flex items-center px-6 sm:px-8 lg:px-12 py-4 border-b border-gray-200">
        <Link to="/" className="flex items-center gap-2">
          <img className="h-9 w-auto" src="/Logo_EzSignly.png" alt="EzSignly" />
        </Link>
      </header>

      {/* Main: two equal columns with vertical divider */}
      <main className="flex-1 flex min-h-0 overflow-hidden">
        {/* Left column - Center aligned heading, subtitle, and images */}
        <div className="hidden lg:flex lg:w-1/2 flex-col items-center justify-center px-8 xl:px-12 py-8 xl:py-16 bg-gray-50 overflow-hidden min-h-0">
          <div className="flex flex-col items-center text-center max-w-md shrink min-h-0">
            <h1 className="font-heading text-xl xl:text-2xl font-semibold text-black mb-2 xl:mb-3 shrink-0">
              Welcome to <span className="text-black/95">EzSignly</span>
            </h1>
            <p className="text-sm xl:text-base text-black/90 leading-relaxed mb-4 xl:mb-6 shrink-0">
              Streamline your document signing process with our secure, fast,
              and user-friendly digital signature platform.
            </p>

            {/* Man and Woman images - Woman behind Man, responsive size */}
            <div className="relative flex items-end justify-center shrink min-h-0">
              <img
                src="/assets/Woman2.png"
                alt=""
                className="relative z-0 w-auto -mb-[30vh] object-contain object-bottom -mr-[8rem] h-[45vh] xl:h-[45vh] 2xl:h-[85vh]"
              />
              <img
                src="/assets/Man1.png"
                alt=""
                className="relative z-10 w-auto -mb-[30vh] object-contain object-bottom h-[45vh] xl:h-[45vh] 2xl:h-[85vh]"
              />
            </div>
          </div>
        </div>

        {/* Vertical divider */}
        <div className="hidden lg:block w-px bg-gray-200 shrink-0" />

        {/* Right column - Auth form */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 sm:px-8 lg:px-12 py-8 overflow-y-auto min-h-0">
          <div className="w-full max-w-md py-4">{children}</div>
        </div>
      </main>

      {/* Footer */}
      <footer className="shrink-0 border-t border-gray-200 px-6 sm:px-8 lg:px-12 py-4 flex justify-center items-center">
        <p className="text-xs text-gray-500">
          EzSignly © {new Date().getFullYear()} All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default AuthLayout;
